<template>
  <div class="widget-card" :class="{ inactive: isInactive }" @click="$emit('edit', widget)">
    <div class="widget-attachment">
      <div v-if="isInactive" class="widget-attachment-overlay"></div>
      <div v-if="imageLink" class="widget-attachment-image" :style="{ backgroundImage: `url(${imageLink})` }"></div>
      <div v-else class="widget-attachment-svg">
        <svg width="100%" height="60" viewBox="0 0 350 60">
          <defs>
            <linearGradient id="gradient" y1="0" y2="1">
              <stop stop-color="rgba(247, 158, 27, 0.7)" offset="0"/>
              <stop stop-color="rgba(235, 0, 27, 0.7)" offset="1"/>
            </linearGradient>
          </defs>
          <g
            style="overflow: hidden; text-anchor: middle; font-weight: 700; font-family: Montserrat; letter-spacing: 2px"
            :style="amountFoalFontSize"
          >
            <text x="175" y="50" style="fill: white; stroke: white; stroke-width: 10; white-space: nowrap">
              {{ displayAmountGoal }}
            </text>
            <text x="175" y="50" style="fill: url(#gradient); stroke: none; stroke-width: 0; white-space: nowrap">
              {{ displayAmountGoal }}
            </text>
          </g>
        </svg>
      </div>
    </div>
    <div class="widget-content">
      <div class="widget-title">{{ widget.description }}</div>
      <div class="widget-amount-bar">{{ displayAmountBar }}</div>
      <progress-loader :percent="progressPercent" :inactive="isInactive" />
      <div v-if="isShownCompletedIcon" class="icon completed"></div>
    </div>
    <div class="widget-actions" @click.stop="$emit('remove', widget)">
      <div class="widget-action">
        <span class="icon trash"></span>
      </div>
      <div class="widget-action" @click.stop="$emit('edit', widget)">
        <span class="icon pencil"></span>
      </div>
      <div class="widget-action" @click.stop="$emit('status', widget)">
        <span
          class="icon"
          :class="{
            play: isInactive,
            stop: !isInactive,
          }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

import ProgressLoader from 'atoms/ProgressLoader';

export default {
  name: 'GoalWidgetCard',
  components: {
    ProgressLoader,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    isInactive() {
      return this.widget.status === 'INACTIVE';
    },
    imageLink() {
      const { attachment } = this.widget;

      if (this.$validate.isNull(attachment)) {
        return null;
      }

      return attachment.link;
    },
    formattedCurrentProgress() {
      const { currentProgress, startFrom } = this.widget;

      if (this.$validate.isNull(currentProgress)) {
        if (this.$validate.isPositiveNumber(startFrom)) {
          return formatAmount(startFrom, {
            significant_zeros: this.currency.significant_zeros,
            type: this.currency.type,
          });
        }

        return 0;
      }

      return formatAmount(currentProgress, {
        significant_zeros: this.currency.significant_zeros,
        type: this.currency.type,
      });
    },
    displayAmountGoal() {
      return formatAmount(this.widget.amountGoal, this.currency);
    },
    displayAmountBar() {
      return `${this.formattedCurrentProgress} / ${formatAmount(this.widget.amountGoal, this.currency)}`;
    },
    progressPercent() {
      if (this.$validate.isNull(this.widget.currentProgressPercent)) {
        return this.widget.startFrom * 100 / this.widget.amountGoal;
      }

      return Number(this.widget.currentProgressPercent);
    },
    isShownCompletedIcon() {
      return this.progressPercent >= 100;
    },
    amountFoalFontSize() {
      const { amountGoal } = this.widget;

      if (amountGoal.toString().length < 10) {
        return 'font-size: 60';
      }

      if (amountGoal.toString().length > 11) {
        return 'font-size: 30';
      }

      return 'font-size: 45';
    },
    ...mapState(['PROJECT_INFO']),
  },
};
</script>

<style lang="sass" scoped>
  @import '~styles/components/widgets/widget-card'

  .widget-title
    min-height: 40px
    margin-bottom: 5px

  .widget-amount-bar
    margin-bottom: 6px
</style>
